import useQuery from '../../../ReactQuery/useQuery';
import { get } from '../../../redux/api';
import type { PaginatedResponse } from '../../../../shared/types/routes/pagination';

const FIVE_MINUTES = 1000 * 60 * 5;

const fetchPackageLocators = (search?: string) => get<PaginatedResponse<string>>(
  '/api/packages/package-locators',
  true,
  {
    count: 10,
    page: 1,
    ...(search ? { packageLocator: search } : {}),
  },
  { encodeQuery: true },
);

export const getPackageLocatorsQueryKey = (search?: string) => [
  'packages',
  'package-locators',
  { search },
];

export default function usePackageLocators(search?: string) {
  return useQuery<PaginatedResponse<string>>({
    queryKey: getPackageLocatorsQueryKey(search),
    queryFn: () => fetchPackageLocators(search),
    staleTime: FIVE_MINUTES,
    // Past searches go inactive as the user types; keep them cached as long as they stay fresh.
    cacheTime: FIVE_MINUTES,
  });
}
